(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1370],{

/***/ 6014:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special-offers/[go_id]",
      function () {
        return __webpack_require__(1782);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SharePopup; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(155);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5434);






function SharePopup(param) {
    var isOpen = param.isOpen, onClose = param.onClose;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), currentUrl = ref[0], setCurrentUrl = ref[1];
    var ref1 = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .useClipboard */ .VPI)(currentUrl), hasCopied = ref1.hasCopied, onCopy = ref1.onCopy;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (true) {
            setCurrentUrl(window.location.href);
        }
    }, []);
    var facebookURL = "https://www.facebook.com/sharer/sharer.php?u=".concat(currentUrl);
    var whatsAppURL = "https://api.whatsapp.com/send?text=".concat(encodeURIComponent(currentUrl));
    var handleFacebookShare = function() {
        if (true) {
            window.open(facebookURL, "_blank");
        }
    };
    var handleWhatsAppShare = function() {
        if (true) {
            window.open(whatsAppURL, "_blank");
        }
    };
    if (!isOpen) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
        position: "fixed",
        top: "0",
        left: "0",
        width: "100vw",
        height: "100vh",
        bg: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: "9999",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
            bg: "white",
            borderRadius: "md",
            p: 6,
            maxWidth: "400px",
            width: "90%",
            position: "relative",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                    position: "absolute",
                    top: 2,
                    right: 2,
                    onClick: onClose,
                    variant: "ghost",
                    size: "sm",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_4__/* .IoClose */ .bjh, {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                    fontSize: "lg",
                    fontWeight: "bold",
                    mb: 4,
                    children: "Share this page"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                    gap: 3,
                    mb: 4,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                            leftIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_4__/* .IoLogoFacebook */ .egd, {}),
                            colorScheme: "facebook",
                            onClick: handleFacebookShare,
                            flex: 1,
                            children: "Facebook"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                            leftIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_4__/* .IoLogoWhatsapp */ .ff9, {}),
                            colorScheme: "whatsapp",
                            bg: "#25D366",
                            _hover: {
                                bg: "#128C7E"
                            },
                            onClick: handleWhatsAppShare,
                            flex: 1,
                            children: "WhatsApp"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                    gap: 2,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Input */ .IIB, {
                            value: currentUrl,
                            readOnly: true,
                            placeholder: currentUrl,
                            flex: 1
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                            leftIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_5__/* .MdContentCopy */ .Fqs, {}),
                            onClick: onCopy,
                            colorScheme: hasCopied ? "green" : "gray",
                            children: hasCopied ? "Copied!" : "Copy"
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 1782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Hotel; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/index.mjs + 808 modules
var dist = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/interweave/esm/index.js + 1 modules
var esm = __webpack_require__(9996);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(9583);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var io5_index_esm = __webpack_require__(155);
// EXTERNAL MODULE: ./node_modules/react-image-lightbox/dist/index.es.js
var index_es = __webpack_require__(2879);
// EXTERNAL MODULE: ./node_modules/react-image-lightbox/style.css
var style = __webpack_require__(3955);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 101 modules
var swiper_esm = __webpack_require__(870);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(1082);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(8352);
// EXTERNAL MODULE: ./src/layout/Section.jsx
var Section = __webpack_require__(1914);
// EXTERNAL MODULE: ./src/utils/const.js
var utils_const = __webpack_require__(3026);
// EXTERNAL MODULE: ./src/utils/functions.js
var functions = __webpack_require__(9735);
// EXTERNAL MODULE: ./src/utils/hooks.js + 1 modules
var hooks = __webpack_require__(1127);
// EXTERNAL MODULE: ./src/components/LinkTo.jsx
var LinkTo = __webpack_require__(6269);
// EXTERNAL MODULE: ./src/components/SharePopup.tsx
var SharePopup = __webpack_require__(1320);
;// CONCATENATED MODULE: ./src/components/DetailPage.jsx





















function DetailPage(param1) {
    var _isParador = param1.isParador, isParador = _isParador === void 0 ? false : _isParador, _isHomepage = param1.isHomepage, isHomepage = _isHomepage === void 0 ? true : _isHomepage, _hotelName = param1.hotelName, hotelName = _hotelName === void 0 ? "" : _hotelName, _hotelCode = param1.hotelCode, hotelCode = _hotelCode === void 0 ? "" : _hotelCode, _hotelLoc = param1.hotelLoc, hotelLoc = _hotelLoc === void 0 ? "" : _hotelLoc, _variant = param1.variant, variant = _variant === void 0 ? "smooth" : _variant, _color = param1.color, color = _color === void 0 ? "black" : _color, headline = param1.headline, subHeadline = param1.subHeadline, _images = param1.images, images = _images === void 0 ? [] : _images, title = param1.title, price = param1.price, desc = param1.desc, _date = param1.date, date = _date === void 0 ? [] : _date, benefits = param1.benefits, tac = param1.tac, brochure = param1.brochure, _promo = param1.promo, promo = _promo === void 0 ? "" : _promo, _rate = param1.rate, rate = _rate === void 0 ? "" : _rate, _coupon = param1.coupon, coupon = _coupon === void 0 ? "" : _coupon, _dest = param1.dest, dest = _dest === void 0 ? "" : _dest, _arrive = param1.arrive, arrive = _arrive === void 0 ? "" : _arrive, _depart = param1.depart, depart = _depart === void 0 ? "" : _depart, connectToSynxis = param1.connectToSynxis, _promoUrl = param1.promoUrl, promoUrl = _promoUrl === void 0 ? "#" : _promoUrl, _backTo = param1.backTo, backTo = _backTo === void 0 ? "/special-offers" : _backTo;
    var router = (0,next_router.useRouter)();
    var locale = (0,hooks/* useLocale */.bU)();
    var hotels = (0,hooks/* useGetListHotel */.e7)().hotels;
    var dates = date ? date.map(function(x) {
        return (0,functions/* timeConvertion */.mQ)({
            UNIX_timestamp: x,
            months: locale == "id" ? utils_const/* monthId */.Cf : utils_const/* monthEn */.Ic
        });
    }) : null;
    var newBenefits = (0,functions/* objParserWP */.aG)(benefits, "benefit");
    var newTac = (0,functions/* objParserWP */.aG)(tac, "tac");
    var ref5 = (0,react.useState)(false), isModalOpen = ref5[0], setIsModalOpen = ref5[1];
    var ref1 = (0,react.useState)(0), photoIdx = ref1[0], setPhotoIdx = ref1[1];
    var ref2 = (0,react.useState)(false), isSharePop = ref2[0], setIsSharePop = ref2[1];
    var shareButtonRef = (0,react.useRef)(null);
    (0,dist/* useOutsideClick */.O3d)({
        ref: shareButtonRef,
        handler: function() {
            return setIsSharePop(false);
        }
    });
    var ref3 = (0,react.useState)(""), selectedHotel = ref3[0], setSelectedHotel = ref3[1];
    var ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
                variant: variant,
                bg: "white",
                color: color,
                suppressHydrationWarning: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Heading */.X6q, {
                            mb: [
                                5,
                                null,
                                null,
                                2
                            ],
                            as: "h1",
                            fontWeight: 400,
                            letterSpacing: "wider",
                            textAlign: "center",
                            children: headline
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                            justify: "space-between",
                            align: "center",
                            w: "100%",
                            mb: 10,
                            color: "blackAlpha.700",
                            fontSize: "small",
                            display: [
                                "none",
                                null,
                                null,
                                "flex"
                            ],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                    flex: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                                        align: "center",
                                        w: "100%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTo/* default */.Z, {
                                            activeColor: "var(--chakra-colors-blackAlpha-500)",
                                            onClick: function() {
                                                return router.back();
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                                align: "center",
                                                gap: 1,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronBack */.dUf, {}),
                                                    locale == "id" ? "Kembali ke halaman Penawaran Spesial" : "Back to Special Offers page"
                                                ]
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                                    flex: 1,
                                    w: "100%",
                                    justify: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                        children: subHeadline
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                    flex: 1
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                            direction: {
                                base: "column-reverse",
                                lg: "row"
                            },
                            h: "100%",
                            w: "100%",
                            gap: 10,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
                                    w: [
                                        "full",
                                        null,
                                        null,
                                        "35%"
                                    ],
                                    fontSize: "sm",
                                    color: "blackAlpha.900",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Heading */.X6q, {
                                            fontSize: "3xl",
                                            letterSpacing: "widest",
                                            fontWeight: 400,
                                            mb: 2,
                                            children: title
                                        }),
                                        !isParador && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                            textTransform: "capitalize",
                                            children: hotelName
                                        }),
                                        price && price > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Text */.xvT, {
                                            mb: 2,
                                            children: [
                                                locale == "id" ? "Harga mulai" : "Start from",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: (0,functions/* formatRupiah */.b7)(price)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                            mb: 3,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Markup */.Lu, {
                                                className: "white-space-enter",
                                                content: (ref4 = desc.replace(/\\n/g, "<br>")) !== null && ref4 !== void 0 ? ref4 : ""
                                            })
                                        }),
                                        dates && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                            align: "center",
                                            gap: 2,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCalendarClearOutline */.Rfe, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Text */.xvT, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: locale == "id" ? "Tersedia: " : "Available: "
                                                        }),
                                                        (0,functions/* getAvailDate */.K6)(dates)
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                            my: 10,
                                            children: (0,functions/* checkAvailDate */.g4)(date) && hotels && price > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                                gap: 4,
                                                h: "100%",
                                                w: "100%",
                                                align: "center",
                                                border: isParador ? "1px solid var(--chakra-colors-gray-700)" : "none",
                                                children: [
                                                    isParador && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Select */.PhF, {
                                                        h: "100%",
                                                        border: 0,
                                                        _focus: {},
                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronDown */.CgR, {
                                                            opacity: 0.5,
                                                            size: "10px"
                                                        }),
                                                        placeholder: "SELECT",
                                                        fontSize: "sm",
                                                        onChange: function(e) {
                                                            setSelectedHotel(e.target.value);
                                                        },
                                                        value: selectedHotel,
                                                        children: hotelName ? hotelName.map(function(name, idx) {
                                                            var ref;
                                                            var tempHotel = (0,lodash.filter)(hotels, function(o) {
                                                                return o.name == name;
                                                            });
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: (ref = tempHotel[0]) === null || ref === void 0 ? void 0 : ref.hotel_code,
                                                                children: name
                                                            }, name + idx);
                                                        }) : hotels.map(function(param, i) {
                                                            var name = param.name, hotel_code = param.hotel_code;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: hotel_code,
                                                                children: name
                                                            }, name + i);
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                                                        h: "100%",
                                                        variant: "dark",
                                                        bg: color,
                                                        borderColor: color,
                                                        _hover: {
                                                            border: "1px solid ".concat(color),
                                                            color: color,
                                                            bg: "white"
                                                        },
                                                        onClick: function() {
                                                            if (connectToSynxis == "false") {
                                                                window.open(promoUrl, "_blank");
                                                            } else {
                                                                var targetCode = isParador ? selectedHotel : hotelCode;
                                                                var cfg = (0,functions/* getBookingEngineHotelConfig */.Np)(targetCode);
                                                                var action = cfg ? cfg.action : "https://www.secure-hotel-booking.com/Parador-Hotels-Resorts/J37Y/search";
                                                                (0,functions/* submitBookingEngineForm */.Sw)({
                                                                    action: action,
                                                                    fields: {
                                                                        language: (0,functions/* getBookingEngineLocale */.cG)(router.locale),
                                                                        arrivalDate: arrive !== null && arrive !== void 0 ? arrive : "",
                                                                        nights: (0,functions/* getBookingEngineNights */.cl)(arrive, depart),
                                                                        guestCountSelector: "ReadOnly",
                                                                        crossSell: "false",
                                                                        selectedAdultCount: "2",
                                                                        rate: rate !== null && rate !== void 0 ? rate : "",
                                                                        promo: promo !== null && promo !== void 0 ? promo : "",
                                                                        coupon: coupon !== null && coupon !== void 0 ? coupon : ""
                                                                    }
                                                                });
                                                            }
                                                        },
                                                        children: locale == "id" ? "Pesan" : "Book Now"
                                                    }),
                                                    connectToSynxis == "true" && promoUrl != "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                                                        h: "100%",
                                                        variant: "dark",
                                                        bg: color,
                                                        borderColor: color,
                                                        _hover: {
                                                            border: "1px solid ".concat(color),
                                                            color: color,
                                                            bg: "white"
                                                        },
                                                        onClick: function() {
                                                            window.open(promoUrl, "_blank");
                                                        },
                                                        children: locale == "id" ? "Reservasi Meja" : "Book A Table"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Accordion */.UQy, {
                                            defaultIndex: [
                                                0,
                                                1,
                                                2
                                            ],
                                            allowMultiple: true,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* AccordionItem */.Qdk, {
                                                    position: "relative",
                                                    _focus: {},
                                                    ref: shareButtonRef,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* AccordionButton */.KFZ, {
                                                                _focus: {},
                                                                onClick: function() {
                                                                    setIsSharePop(!isSharePop);
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                                                    flex: "1",
                                                                    align: "center",
                                                                    gap: 2,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaShare */.Lrt, {}),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                                                            pl: 0.5,
                                                                            fontWeight: 600,
                                                                            children: locale == "id" ? "Bagikan" : "Share"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        isSharePop && /*#__PURE__*/ (0,jsx_runtime.jsx)(SharePopup/* default */.Z, {
                                                            isOpen: isSharePop,
                                                            onClose: function() {
                                                                return setIsSharePop(false);
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                                            pb: 6
                                                        })
                                                    ]
                                                }),
                                                brochure && (brochure === null || brochure === void 0 ? void 0 : brochure.url) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* AccordionItem */.Qdk, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* AccordionButton */.KFZ, {
                                                                pl: [
                                                                    0,
                                                                    null,
                                                                    null,
                                                                    4
                                                                ],
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                                                    flex: "1",
                                                                    align: "center",
                                                                    gap: 2,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaRegFilePdf */.B$y, {}),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                                                            pl: 0.5,
                                                                            fontWeight: 600,
                                                                            children: locale == "id" ? "Unduh" : "Downloads"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* AccordionPanel */.Hk3, {
                                                            pb: 6,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                                                                flexDir: "column",
                                                                gap: 4,
                                                                ml: "1.6rem",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "http://docs.google.com/viewerng/viewer?url=".concat(brochure === null || brochure === void 0 ? void 0 : brochure.url),
                                                                    isExternal: true,
                                                                    children: locale == "id" ? "Brosur" : "Brochure"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                newBenefits && newBenefits.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* AccordionItem */.Qdk, {
                                                    pt: 0,
                                                    children: function(param) {
                                                        var isExpanded = param.isExpanded;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* AccordionButton */.KFZ, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                                                            flex: "1",
                                                                            align: "center",
                                                                            gap: 2,
                                                                            children: [
                                                                                !isExpanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoAddOutline */.b0B, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoRemoveOutline */.n2U, {}),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                                                                    pl: 0.5,
                                                                                    fontWeight: 600,
                                                                                    children: locale == "id" ? "Keuntungan" : "Benefits"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* AccordionPanel */.Hk3, {
                                                                    py: 6,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* UnorderedList */.QI$, {
                                                                        display: "flex",
                                                                        flexDir: "column",
                                                                        gap: 4,
                                                                        children: newBenefits.map(function(v) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ListItem */.HCh, {
                                                                                pl: 2,
                                                                                ml: 1,
                                                                                children: v
                                                                            }, v);
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        });
                                                    }
                                                }),
                                                newTac && newTac.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* AccordionItem */.Qdk, {
                                                    pt: 0,
                                                    children: function(param) {
                                                        var isExpanded = param.isExpanded;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* AccordionButton */.KFZ, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                                                            flex: "1",
                                                                            align: "center",
                                                                            gap: 2,
                                                                            children: [
                                                                                !isExpanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoAddOutline */.b0B, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoRemoveOutline */.n2U, {}),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                                                                    pl: 0.5,
                                                                                    fontWeight: 600,
                                                                                    children: locale == "id" ? "Syarat & Ketentuan" : "Terms & Conditions"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* AccordionPanel */.Hk3, {
                                                                    py: 6,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* UnorderedList */.QI$, {
                                                                        display: "flex",
                                                                        flexDir: "column",
                                                                        gap: 4,
                                                                        children: newTac.map(function(v) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ListItem */.HCh, {
                                                                                pl: 2,
                                                                                ml: 1,
                                                                                children: v
                                                                            }, v);
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        });
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                    w: [
                                        "full",
                                        null,
                                        null,
                                        "65%"
                                    ],
                                    h: [
                                        "40vh",
                                        null,
                                        null,
                                        "100vh"
                                    ],
                                    position: "relative",
                                    className: "section-swiper-v2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                        centeredSlides: true,
                                        loop: images.length > 1,
                                        pagination: {
                                            clickable: true
                                        },
                                        autoplay: {
                                            delay: 8000,
                                            pauseOnMouseEnter: true,
                                            disableOnInteraction: true
                                        },
                                        modules: images.length > 1 ? [
                                            swiper_esm/* Autoplay */.pt,
                                            swiper_esm/* Pagination */.tl
                                        ] : [],
                                        children: images.map(function(param, i) {
                                            var url = param.url, id = param.id;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                                    w: "100%",
                                                    h: "100%",
                                                    position: "relative",
                                                    cursor: "pointer",
                                                    onClick: function() {
                                                        setIsModalOpen(true);
                                                        setPhotoIdx(i);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        alt: "",
                                                        src: (0,functions/* convertImgHttps */.Nu)(url),
                                                        layout: "fill",
                                                        objectFit: "contain",
                                                        objectPosition: "top",
                                                        priority: true,
                                                        unoptimized: true
                                                    })
                                                })
                                            }, id);
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            isModalOpen && images.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                mainSrc: images[photoIdx].url,
                nextSrc: images[(photoIdx + 1) % images.length],
                prevSrc: images[(photoIdx + images.length - 1) % images.length],
                onCloseRequest: function() {
                    return setIsModalOpen(false);
                },
                onMovePrevRequest: function() {
                    return setPhotoIdx((photoIdx + images.length - 1) % images.length);
                },
                onMoveNextRequest: function() {
                    return setPhotoIdx((photoIdx + 1) % images.length);
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/containers/Helmet.tsx + 1 modules
var Helmet = __webpack_require__(9536);
// EXTERNAL MODULE: ./src/layout/FooterHotel.jsx
var FooterHotel = __webpack_require__(8078);
// EXTERNAL MODULE: ./src/layout/HeaderV3.tsx + 4 modules
var HeaderV3 = __webpack_require__(4850);
// EXTERNAL MODULE: ./src/utils/mediaQuery.js
var mediaQuery = __webpack_require__(9741);
;// CONCATENATED MODULE: ./src/pages/special-offers/[go_id].tsx










var __N_SSG = true;
function Hotel(param) {
    var header = param.header, hotelBrands = param.hotelBrands, offer = param.offer, isGroupOffer = param.isGroupOffer;
    var router = (0,next_router.useRouter)();
    var ref = (0,next_router.useRouter)(), locale = ref.locale, locales = ref.locales, asPath = ref.asPath;
    var go_id = router.query.go_id;
    var ref1 = (0,react.useState)(0), headerHeight = ref1[0], setHeaderHeight = ref1[1];
    var images = offer.images, title = offer.title, start_from = offer.start_from, desc_long = offer.desc_long, desc_long_id = offer.desc_long_id, date_start = offer.date_start, date_end = offer.date_end, benefits = offer.benefits, benefits_id = offer.benefits_id, tac = offer.tac, tac_id = offer.tac_id, hotel_name = offer.hotel_name, hotel_names = offer.hotel_names, promo = offer.promo, rate = offer.rate, connect_to_synxis = offer.connect_to_synxis, promo_url = offer.promo_url, coupon = offer.coupon, dest = offer.dest, arrive = offer.arrive, depart = offer.depart, meta_title_id = offer.meta_title_id, meta_title_en = offer.meta_title_en, meta_desc_id = offer.meta_desc_id, meta_desc_en = offer.meta_desc_en, meta_thumb = offer.meta_thumb, brochures = offer.brochures;
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Helmet/* default */.Z, {
                title: !(0,lodash.isEmpty)(meta_title_id) && router.locale == "id" ? meta_title_id : !(0,lodash.isEmpty)(meta_title_en) ? meta_title_en : "".concat(title, " - ").concat(isGroupOffer ? "Group Offers" : "Hotel Offers").concat(isGroupOffer ? "" : " | " + hotel_name, " | Parador Hotels & Resorts"),
                description: router.locale == "id" ? !(0,lodash.isEmpty)(meta_desc_id) ? meta_desc_id : desc_long_id : !(0,lodash.isEmpty)(meta_desc_en) ? meta_desc_en : desc_long,
                image: !(0,lodash.isEmpty)(meta_thumb) ? meta_thumb : (ref2 = images[0]) !== null && ref2 !== void 0 ? ref2 : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderV3/* default */.Z, {
                headerItem: header,
                isHomepage: false,
                hotelBrands: hotelBrands
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailPage, {
                variant: "flat",
                headline: isGroupOffer ? router.locale == "id" ? "Penawaran Grup" : "Group Offers" : router.locale == "id" ? "Penawaran Hotel" : "Hotel Offers",
                subHeadline: router.locale == "id" ? "Nikmati Penawaran & Promosinya" : "Enjoy the offers & promotions",
                isParador: isGroupOffer,
                hotelName: isGroupOffer ? hotel_names : hotel_name,
                color: header.color_primary,
                images: images,
                title: title,
                price: start_from,
                desc: router.locale == "id" ? desc_long_id : desc_long,
                date: [
                    date_start,
                    date_end
                ],
                benefits: router.locale == "id" ? benefits_id : benefits,
                tac: router.locale == "id" ? tac_id : tac,
                promo: promo,
                rate: rate,
                connectToSynxis: connect_to_synxis,
                promoUrl: promo_url,
                coupon: coupon,
                dest: dest,
                arrive: arrive,
                depart: depart,
                hotelCode: (0,lodash.toString)(header.hotel_code),
                brochure: brochures
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                px: mediaQuery/* safeMarginX */.Mp,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {
                    orientation: "horizontal",
                    borderColor: "black",
                    bg: "black",
                    opacity: 0.2
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterHotel/* default */.Z, {
                hotelSlug: header.slug,
                instagram: header.instagram,
                facebook: header.facebook,
                locationLink: header.location_url,
                location: header.location_long,
                email: header.email,
                phone: header.phone,
                bg: header.color_primary,
                color: "white",
                logo: header.logo_light
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,1228,5525,6394,9996,9392,4939,8078,9774,2888,179], function() { return __webpack_exec__(6014); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);